import React from 'react';
import { createRoot } from 'react-dom/client';

import SlopesAndLifts from './SlopesAndLifts';

const root = createRoot(document.getElementById('slopes_and_lifts'));

root.render(
  <React.StrictMode>
    <SlopesAndLifts />
  </React.StrictMode>
);
